import FieldInputRenderer from '../fields/FieldInputRenderer';

const isUrlField = (field) =>
  field.key === 'url' || field.key.endsWith('-url') || field.fieldType === 'url';

const MarketsPostEditor = ({ index, fields, fieldValues, onFieldChange }) => {
  const categoryField = fields.find((field) => field.key.endsWith('-category'));
  const urlField = fields.find((field) => field.key.endsWith('-url'));
  const category = categoryField ? fieldValues[categoryField.id] : `Post ${index}`;
  const editableFields = fields.filter((field) => !isUrlField(field));

  return (
    <article className="rounded-md border border-[#e4d9c8] bg-[#faf8f4] p-4">
      <div className="mb-4 border-b border-[#e4d9c8] pb-3">
        <p className="text-[11px] font-medium uppercase tracking-[0.14em] text-[#6b635c]">
          Post {index}
        </p>
        <p className="mt-1 text-sm font-semibold text-[#130705]">{category || 'Untitled post'}</p>
        {urlField && fieldValues[urlField.id] ? (
          <p className="mt-0.5 truncate text-[11px] text-[#a8a098]">{fieldValues[urlField.id]}</p>
        ) : null}
      </div>

      <div className="grid gap-3">
        {editableFields.map((field) => (
          <div key={field.id}>
            <label
              htmlFor={`field-${field.id}`}
              className="mb-1.5 block text-[12px] font-medium text-[#6b635c]"
            >
              {field.label}
            </label>
            <FieldInputRenderer
              field={field}
              value={fieldValues[field.id] || ''}
              onChange={(value) => onFieldChange(field.id, value)}
            />
          </div>
        ))}
      </div>
    </article>
  );
};

export default MarketsPostEditor;
